import React from "react";
//import { Parallax } from "react-parallax";
import Footer from "./Footer";
import Header from "./Header";
import image2 from "../Assets/wp3589952.webp";
import { Link } from "react-router-dom";

function Thanks() {
  return (
    <div>
      <div className="main">
        <Header />

        {/* Parallax Section */}

        <div
          className="content-section"
          style={{ backgroundImage: `url(${image2})`}}
        >
          <h1
            style={{
              color: "white",
              // paddingTop: "100px",
              textAlign: "center", 
            }}
          >
            Thanks
          </h1>
          <p
            style={{
              display: "flex",
              justifyContent: "center",
              color: "white",
            }}
          >
            <Link to="/" style={{ color: "white" }}>
              Home
            </Link>
            <i className="bi bi-chevron-right"></i> Thanks
          </p>
        </div>

        <div className="privacy-content" style={{ padding: "20px" }}>
          {/* Render privacy content */}
          {/* Check if privacyContent is a string before rendering */}

          <h3>
            {" "}
            Thanks For Your Enquiry. We Will Contact You Soon, Please Check Your
            Email.
          </h3>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Thanks;
